import React from "react";
import Navbar from "../components/Navbar";
import CreateHashForm from "../components/CreateHashForm";
import { WalletInfo } from "../contexts/WalletContext";
import { useAccount, useDisconnect } from "wagmi";

import "./CreateHashPage.css";

function CreateHashPage() {
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();

  return (
    <div className="create-hash-page">
      <Navbar activePage="create-hash" />
      <CreateHashForm isConnected={isConnected} address={address} />
    </div>
  );
}

export default CreateHashPage;
